/* PRINCESAS — theme.js (vanilla, sem dependências) */
(function () {
  'use strict';
  var T = window.theme || {};
  var R = T.routes || {};
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var store = {
    get: function (k) { try { return localStorage.getItem(k); } catch (e) { return null; } },
    set: function (k, v) { try { localStorage.setItem(k, v); } catch (e) {} },
    del: function (k) { try { localStorage.removeItem(k); } catch (e) {} }
  };

  /* ---------- Money ---------- */
  function money(cents) {
    var fmt = T.moneyFormat || '{{amount_with_comma_separator}} €';
    var n = (cents / 100).toFixed(2);
    var parts = n.split('.');
    var intp = parts[0];
    var withDot = intp.replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',' + parts[1];
    var withComma = intp.replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '.' + parts[1];
    var noDec = intp.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    return fmt
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, withDot)
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/, noDec)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, intp)
      .replace(/\{\{\s*amount_with_space_separator\s*\}\}/, intp.replace(/\B(?=(\d{3})+(?!\d))/g, ' ') + ',' + parts[1])
      .replace(/\{\{\s*amount\s*\}\}/, withComma);
  }

  /* ---------- Toast ---------- */
  function toast(msg, type) {
    var region = $('#toast-region');
    if (!region) return;
    var el = document.createElement('div');
    el.setAttribute('role', 'status');
    el.className = 'pointer-events-auto border bg-background px-5 py-3 text-sm shadow-lg ' + (type === 'error' ? 'border-terracotta text-terracotta' : 'border-petrol text-petrol');
    el.textContent = msg;
    region.appendChild(el);
    setTimeout(function () { el.style.transition = 'opacity .3s'; el.style.opacity = '0'; setTimeout(function () { el.remove(); }, 320); }, 3200);
  }
  window.theme.toast = toast;

  /* ---------- Overlays ---------- */
  var lastFocus = null;
  function openOverlay(name) {
    var o = $('[data-overlay="' + name + '"]');
    if (!o) return;
    lastFocus = document.activeElement;
    o.hidden = false;
    document.body.classList.add('overlay-open');
    var f = $('[data-search-input]', o) || $('button, a, input', o);
    if (name === 'search' && f) setTimeout(function () { f.focus(); }, 30);
  }
  function closeOverlays() {
    $$('[data-overlay]').forEach(function (o) { o.hidden = true; });
    document.body.classList.remove('overlay-open');
    if (lastFocus && lastFocus.focus) { try { lastFocus.focus(); } catch (e) {} }
  }
  function anyOverlayOpen() { return $$('[data-overlay]').some(function (o) { return !o.hidden; }); }

  /* ---------- Cart ---------- */
  function fetchJSON(url, opts) {
    return fetch(url, Object.assign({ headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, credentials: 'same-origin' }, opts || {}))
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) { var e = new Error(j.description || j.message || 'Erro'); e.data = j; throw e; } return j; }); });
  }
  function setCartCount(n) {
    $$('[data-cart-count]').forEach(function (el) { el.textContent = n; el.hidden = !n; });
  }
  function refreshCart(opts) {
    opts = opts || {};
    var wasOpen = !!($('[data-overlay="cart"]') && !$('[data-overlay="cart"]').hidden);
    var sections = ['cart-drawer'];
    var url = (R.root || '/') + '?sections=' + sections.join(',');
    return fetch(url, { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (data) {
      if (data['cart-drawer']) {
        var doc = new DOMParser().parseFromString(data['cart-drawer'], 'text/html');
        var fresh = $('#cart-drawer-content', doc);
        var cur = $('#cart-drawer-content');
        if (fresh && cur) cur.innerHTML = fresh.innerHTML;
      }
      return fetch((R.cart || '/cart') + '.js').then(function (r) { return r.json(); });
    }).then(function (cart) {
      setCartCount(cart.item_count);
      if (opts.open || wasOpen) openOverlay('cart');
      var page = $('#CartPage');
      if (page && opts.reloadPage !== false) {
        return fetch(location.pathname + '?section_id=main-cart', { credentials: 'same-origin' }).then(function (r) { return r.text(); }).then(function (html) {
          var d = new DOMParser().parseFromString(html, 'text/html');
          var np = $('#CartPage', d);
          if (np) page.innerHTML = np.innerHTML; else location.reload();
        }).catch(function () { location.reload(); });
      }
    });
  }
  function addToCart(items) {
    return fetchJSON(R.cartAdd || '/cart/add.js', { method: 'POST', body: JSON.stringify({ items: items }) });
  }
  window.theme.addToCart = addToCart;
  window.theme.refreshCart = refreshCart;

  document.addEventListener('click', function (e) {
    var t = e.target;
    var op = t.closest('[data-open-overlay]');
    if (op) { e.preventDefault(); closeOverlays(); openOverlay(op.getAttribute('data-open-overlay')); return; }
    if (t.closest('[data-close-overlay]')) { e.preventDefault(); closeOverlays(); return; }

    var ch = t.closest('[data-cart-change]');
    if (ch) {
      e.preventDefault();
      ch.disabled = true;
      fetchJSON(R.cartChange || '/cart/change.js', { method: 'POST', body: JSON.stringify({ line: +ch.getAttribute('data-line'), quantity: +ch.getAttribute('data-quantity') }) })
        .then(function () { return refreshCart(); })
        .catch(function (err) { toast(err.message || 'Não foi possível atualizar o carrinho.', 'error'); ch.disabled = false; });
      return;
    }

    var wl = t.closest('[data-wishlist-toggle]');
    if (wl) { e.preventDefault(); e.stopPropagation(); toggleWish(wl.getAttribute('data-wishlist-toggle'), wl.getAttribute('data-wishlist-name')); return; }

    var al = t.closest('[data-add-look]');
    if (al) {
      e.preventDefault();
      var ids = al.getAttribute('data-add-look').split(',').filter(Boolean).map(function (id) { return { id: +id, quantity: 1 }; });
      if (!ids.length) return;
      al.disabled = true;
      addToCart(ids).then(function () { toast('Look adicionado ao carrinho.'); return refreshCart({ open: true }); })
        .catch(function (err) { toast(err.message || 'Algumas peças não estão disponíveis.', 'error'); })
        .then(function () { al.disabled = false; });
      return;
    }

    var cd = t.closest('[data-clear-data]');
    if (cd) {
      e.preventDefault();
      ['princesas.wishlist', 'princesas.cookies'].forEach(store.del);
      fetchJSON(R.cartClear || '/cart/clear.js', { method: 'POST', body: '{}' }).catch(function () {}).then(function () {
        syncWish(); setCartCount(0); toast('Dados deste navegador apagados.');
        setTimeout(function () { location.reload(); }, 900);
      });
      return;
    }

    var cc = t.closest('[data-cookie-choice]');
    if (cc) {
      store.set('princesas.cookies', cc.getAttribute('data-cookie-choice'));
      var b = $('[data-cookie-banner]'); if (b) b.hidden = true;
      return;
    }

    var st = t.closest('[data-search-term]');
    if (st) { var inp = $('[data-search-input]'); if (inp) { inp.value = st.getAttribute('data-search-term'); inp.dispatchEvent(new Event('input', { bubbles: true })); inp.focus(); } return; }

    // dropdowns
    $$('[data-dropdown][open]').forEach(function (d) { if (!d.contains(t)) d.removeAttribute('open'); });
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      if (anyOverlayOpen()) closeOverlays();
      closeMega();
      $$('[data-dropdown][open]').forEach(function (d) { d.removeAttribute('open'); });
    }
  });

  /* ---------- Mega menu ---------- */
  var megaRoot, megaTimer;
  function closeMega() {
    $$('[data-mega-panel]').forEach(function (p) { p.hidden = true; });
    $$('[data-mega-trigger]').forEach(function (t) { t.setAttribute('aria-expanded', 'false'); });
  }
  function openMega(name) {
    $$('[data-mega-panel]').forEach(function (p) { p.hidden = p.getAttribute('data-mega-panel') !== name; });
    $$('[data-mega-trigger]').forEach(function (t) { t.setAttribute('aria-expanded', t.getAttribute('data-mega-trigger') === name ? 'true' : 'false'); });
  }
  function initMega() {
    megaRoot = $('[data-mega-root]');
    if (!megaRoot) return;
    $$('[data-mega-trigger]', megaRoot).forEach(function (t) {
      var n = t.getAttribute('data-mega-trigger');
      var go = function () { clearTimeout(megaTimer); if (n === 'none') closeMega(); else openMega(n); };
      t.addEventListener('mouseenter', go);
      t.addEventListener('focus', go);
    });
    megaRoot.addEventListener('mouseenter', function () { clearTimeout(megaTimer); });
    megaRoot.addEventListener('mouseleave', function () { megaTimer = setTimeout(closeMega, 120); });
    megaRoot.addEventListener('focusout', function (e) { if (!megaRoot.contains(e.relatedTarget)) closeMega(); });
    $$('a', megaRoot).forEach(function (a) { a.addEventListener('click', closeMega); });
  }

  /* ---------- Wishlist ---------- */
  function readWish() { try { var v = JSON.parse(store.get('princesas.wishlist') || '[]'); return Array.isArray(v) ? v : []; } catch (e) { return []; } }
  function writeWish(l) { store.set('princesas.wishlist', JSON.stringify(l)); }
  function toggleWish(handle, name) {
    if (!handle) return;
    var l = readWish(); var i = l.indexOf(handle);
    if (i > -1) { l.splice(i, 1); toast((name || 'Peça') + ' retirada dos favoritos.'); }
    else { l.push(handle); toast((name || 'Peça') + ' guardada nos favoritos.'); }
    writeWish(l); syncWish();
  }
  function syncWish() {
    var l = readWish();
    $$('[data-wishlist-toggle]').forEach(function (b) {
      var on = l.indexOf(b.getAttribute('data-wishlist-toggle')) > -1;
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    $$('[data-wishlist-count]').forEach(function (c) { c.textContent = l.length; c.hidden = !l.length; });
    renderWishPage(l);
  }
  var wishRendered = '';
  function renderWishPage(l) {
    var page = $('[data-wishlist-page]');
    if (!page) return;
    var empty = $('[data-wishlist-empty]', page), grid = $('[data-wishlist-grid]', page);
    if (!l.length) { if (empty) empty.hidden = false; if (grid) { grid.hidden = true; grid.innerHTML = ''; } wishRendered = ''; return; }
    if (empty) empty.hidden = true;
    if (grid) grid.hidden = false;
    var key = l.join('|');
    if (key === wishRendered) return;
    wishRendered = key;
    var view = page.getAttribute('data-card-view') || 'card';
    Promise.all(l.map(function (h) {
      return fetch('/products/' + encodeURIComponent(h) + '?view=' + view, { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.text() : ''; }).catch(function () { return ''; });
    })).then(function (parts) {
      var html = parts.filter(Boolean).join('');
      grid.innerHTML = html;
      syncWishButtonsOnly();
    });
  }
  function syncWishButtonsOnly() {
    var l = readWish();
    $$('[data-wishlist-toggle]').forEach(function (b) { b.setAttribute('aria-pressed', l.indexOf(b.getAttribute('data-wishlist-toggle')) > -1 ? 'true' : 'false'); });
  }

  /* ---------- Hero slider ---------- */
  function initHero() {
    $$('[data-hero]').forEach(function (hero) {
      var slides = $$('[data-slide]', hero), dots = $$('[data-hero-dot]', hero);
      if (slides.length < 2) return;
      var i = 0, timer = null, secs = parseFloat(hero.getAttribute('data-autoplay')) || 0;
      function show(n) {
        i = (n + slides.length) % slides.length;
        slides.forEach(function (s, k) {
          var on = k === i;
          s.style.opacity = on ? '1' : '0';
          s.style.pointerEvents = on ? 'auto' : 'none';
          s.setAttribute('aria-hidden', on ? 'false' : 'true');
          s.classList.toggle('is-active', on);
          $$('a,button', s).forEach(function (x) { x.tabIndex = on ? 0 : -1; });
        });
        dots.forEach(function (d, k) { d.setAttribute('aria-current', k === i ? 'true' : 'false'); d.classList.toggle('is-active', k === i); });
      }
      function play() { stop(); if (secs && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) timer = setInterval(function () { show(i + 1); }, secs * 1000); }
      function stop() { if (timer) clearInterval(timer); timer = null; }
      dots.forEach(function (d, k) { d.addEventListener('click', function () { show(k); play(); }); });
      var p = $('[data-hero-prev]', hero), n = $('[data-hero-next]', hero);
      if (p) p.addEventListener('click', function () { show(i - 1); play(); });
      if (n) n.addEventListener('click', function () { show(i + 1); play(); });
      hero.addEventListener('mouseenter', stop); hero.addEventListener('mouseleave', play);
      hero.addEventListener('focusin', stop); hero.addEventListener('focusout', play);
      show(0); play();
    });
  }

  /* ---------- Product page ---------- */
  function initProduct() {
    var root = $('[data-product-root]');
    if (!root) return;
    var jsonEl = $('script[data-product-json]', root) || $('script[data-product-json]');
    var variants = [];
    try { variants = JSON.parse(jsonEl.textContent); } catch (e) {}
    var form = $('[data-product-form]', root), idInput = $('[data-variant-id]', root);
    var btn = $('[data-add-to-cart]', root), label = $('[data-add-label]', root), stock = $('[data-stock-note]', root);
    var errEl = $('[data-form-error]', root);
    var price = $('[data-price]', root), compare = $('[data-compare-price]', root);
    var qty = $('[data-qty-input]', root);

    function chosen() {
      return $$('fieldset[data-option-index]', root).map(function (fs) {
        var c = $('input:checked', fs); return c ? c.value : null;
      });
    }
    function current() {
      var sel = chosen();
      return variants.filter(function (v) { return sel.every(function (s, k) { return s === null || v['option' + (k + 1)] === s; }); })[0];
    }
    function update() {
      var v = current();
      $$('fieldset[data-option-index]', root).forEach(function (fs) {
        var c = $('input:checked', fs), out = $('[data-option-selected]', fs);
        if (out && c) out.textContent = '— ' + c.value;
      });
      if (!v) {
        if (btn) btn.disabled = true;
        if (label) label.textContent = 'Indisponível';
        if (stock) stock.textContent = 'Combinação indisponível';
        return;
      }
      if (idInput) idInput.value = v.id;
      if (btn) btn.disabled = !v.available;
      if (label) label.textContent = v.available ? 'Adicionar ao carrinho' : 'Esgotado';
      if (stock) stock.textContent = v.available ? 'Em stock' : 'Esgotado de momento';
      if (price) price.textContent = money(v.price);
      if (compare) {
        if (v.compare_at_price && v.compare_at_price > v.price) { compare.textContent = money(v.compare_at_price); compare.classList.remove('hidden'); }
        else { compare.textContent = ''; compare.classList.add('hidden'); }
      }
      if (v.featured_media && v.featured_media.id) {
        var th = $('[data-thumb][data-media-id="' + v.featured_media.id + '"]', root);
        if (th) selectThumb(th);
      }
      // reflect in URL
      try { var u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState(null, '', u); } catch (e) {}
    }
    function selectThumb(th) {
      var main = $('[data-main-image]', root);
      if (main) {
        main.src = th.getAttribute('data-src');
        var ss = th.getAttribute('data-srcset'); if (ss) main.srcset = ss; else main.removeAttribute('srcset');
        main.alt = th.getAttribute('data-alt') || '';
      }
      $$('[data-thumb]', root).forEach(function (x) { x.setAttribute('aria-pressed', x === th ? 'true' : 'false'); });
    }
    $$('[data-thumb]', root).forEach(function (th) { th.addEventListener('click', function () { selectThumb(th); }); });
    $$('fieldset[data-option-index] input', root).forEach(function (i) { i.addEventListener('change', update); });

    function clamp() { var n = parseInt(qty.value, 10); if (!(n > 0)) n = 1; if (n > 99) n = 99; qty.value = n; return n; }
    if (qty) {
      var m = $('[data-qty-minus]', root), p = $('[data-qty-plus]', root);
      if (m) m.addEventListener('click', function () { qty.value = Math.max(1, clamp() - 1); });
      if (p) p.addEventListener('click', function () { qty.value = Math.min(99, clamp() + 1); });
      qty.addEventListener('change', clamp);
    }

    if (form) form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (errEl) { errEl.hidden = true; errEl.textContent = ''; }
      var v = current();
      if (!v || !v.available) return;
      var n = qty ? clamp() : 1;
      btn.disabled = true;
      var old = label ? label.textContent : '';
      if (label) label.textContent = 'A adicionar…';
      addToCart([{ id: v.id, quantity: n }]).then(function () {
        toast('Adicionado ao carrinho.');
        return refreshCart({ open: true });
      }).catch(function (err) {
        var msg = err.message || 'Não foi possível adicionar ao carrinho.';
        if (errEl) { errEl.textContent = msg; errEl.hidden = false; } else toast(msg, 'error');
      }).then(function () { btn.disabled = false; if (label) label.textContent = old; });
    });
    update();
  }

  /* ---------- Recommendations ---------- */
  function initRecs() {
    $$('[data-recommendations]').forEach(function (el) {
      var url = el.getAttribute('data-url');
      if (!url) return;
      fetch(url, { credentials: 'same-origin' }).then(function (r) { return r.text(); }).then(function (html) {
        var d = new DOMParser().parseFromString(html, 'text/html');
        var fresh = $('[data-recommendations]', d);
        if (fresh && fresh.innerHTML.trim()) { el.innerHTML = fresh.innerHTML; syncWishButtonsOnly(); }
        else { var sec = el.closest('section'); if (sec) sec.hidden = true; }
      }).catch(function () {});
    });
  }

  /* ---------- Filters ---------- */
  function initFilters() {
    $$('[data-filter-form]').forEach(function (f) {
      f.addEventListener('change', function () { f.submit(); });
    });
    $$('[data-sort-select]').forEach(function (s) {
      s.addEventListener('change', function () {
        var u = new URL(location.href); u.searchParams.set('sort_by', s.value); u.searchParams.delete('page'); location.href = u.toString();
      });
    });
  }

  /* ---------- FAQ ---------- */
  function initFaq() {
    $$('[data-faq]').forEach(function (root) {
      var q = $('[data-faq-search]', root), cats = $$('[data-faq-category]', root), items = $$('[data-faq-item]', root), empty = $('[data-faq-empty]', root);
      var cat = 'all';
      function norm(s) { return (s || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, ''); }
      function apply() {
        var term = norm(q && q.value).trim(), shown = 0;
        items.forEach(function (it) {
          var ok = (cat === 'all' || it.getAttribute('data-category') === cat) && (!term || norm(it.getAttribute('data-text')).indexOf(term) > -1);
          it.hidden = !ok; if (ok) shown++;
        });
        if (empty) empty.hidden = shown > 0;
      }
      if (q) q.addEventListener('input', apply);
      cats.forEach(function (c) {
        c.addEventListener('click', function () {
          cat = c.getAttribute('data-faq-category') || 'all';
          cats.forEach(function (x) { x.setAttribute('aria-pressed', x === c ? 'true' : 'false'); });
          apply();
        });
      });
      apply();
    });
  }

  /* ---------- Search overlay (predictive) ---------- */
  function initSearch() {
    var input = $('[data-search-input]'), out = $('[data-search-results]'), sugg = $('[data-search-suggestions]');
    if (!input || !out) return;
    var timer, ctl;
    input.addEventListener('input', function () {
      clearTimeout(timer);
      var v = input.value.trim();
      if (v.length < 2) { out.innerHTML = ''; if (sugg) sugg.hidden = false; return; }
      if (sugg) sugg.hidden = true;
      timer = setTimeout(function () {
        if (ctl) ctl.abort();
        ctl = window.AbortController ? new AbortController() : null;
        var url = (R.searchSuggest || '/search/suggest') + '?q=' + encodeURIComponent(v) + '&section_id=predictive-search&resources[type]=product,collection,page&resources[limit]=6';
        fetch(url, { signal: ctl && ctl.signal, credentials: 'same-origin' }).then(function (r) { return r.text(); }).then(function (html) {
          var d = new DOMParser().parseFromString(html, 'text/html');
          var sec = $('#shopify-section-predictive-search', d) || d.body;
          out.innerHTML = sec.innerHTML;
          syncWishButtonsOnly();
        }).catch(function () {});
      }, 220);
    });
  }

  /* ---------- Tracking form (opens WhatsApp) ---------- */
  function initTracking() {
    var form = $('[data-tracking-form]');
    if (!form) return;
    var input = $('[data-tracking-input]', form);
    var numEl = $('script[data-wa-number]');
    var num = (numEl && numEl.getAttribute('data-wa-number')) || (T.whatsapp || '').replace(/\D/g, '');
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var ref = (input.value || '').trim();
      if (!ref) { input.focus(); return; }
      var msg = 'Olá PRINCESAS! Gostaria de saber onde está a encomenda ' + ref + '.';
      window.open('https://wa.me/' + String(num).replace(/\D/g, '') + '?text=' + encodeURIComponent(msg), '_blank', 'noopener');
    });
  }

  /* ---------- Cookie banner ---------- */
  function initCookies() {
    var b = $('[data-cookie-banner]');
    if (b && !store.get('princesas.cookies')) b.hidden = false;
  }

  /* ---------- Boot ---------- */
  function boot() {
    initMega(); initHero(); initProduct(); initRecs(); initFilters(); initFaq(); initSearch(); initTracking(); initCookies();
    syncWish();
    window.addEventListener('storage', syncWish);
    window.addEventListener('pageshow', function (e) { if (e.persisted) { syncWish(); refreshCart({ reloadPage: false }).catch(function () {}); } });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
